import { watchEffect, onScopeDispose } from "vue";
import { useElementBounding, useWindowSize } from "@vueuse/core";
const FLOATING_CLEARANCE_GAP_PX = 8;
/**
 * Publishes the floating element's occupied bottom space (its top edge relative
 * to the viewport bottom, plus a small gap) as a CSS variable on `:root`, so
 * any peer at the same corner can sit clear of it via
 * `bottom: max(<own gutter>, var(--rec-floating-{side}-clearance, 0px))`.
 */
export const useFloatingClearance = (elementRef, side) => {
    const { top, height } = useElementBounding(elementRef);
    const { height: windowHeight } = useWindowSize();
    const cssVar = `--rec-floating-${side}-clearance`;
    watchEffect(() => {
        // Hidden via display:none ⇒ rect is all-zero; signal "no clearance".
        const value = height.value > 0 ? windowHeight.value - top.value + FLOATING_CLEARANCE_GAP_PX : 0;
        document.documentElement.style.setProperty(cssVar, `${value}px`);
    });
    onScopeDispose(() => {
        document.documentElement.style.removeProperty(cssVar);
    });
};
